const state = {
  langue: 'fr'
}

const mutations = {
  CHANGE_LANGUE (state, payload) {
    state.langue = payload
  }
}

const actions = {
  changeLangue ({ commit }, langueChoisie) {
    commit('CHANGE_LANGUE', langueChoisie)
  }
}

const getters = {
  langue: state => state.langue
}
const langue = {
  state,
  mutations,
  actions,
  getters
}

export default langue



// WEBPACK FOOTER //
// ./src/store/modules/langage/index.js